import PropTypes from 'prop-types'

import styles from './OtaBuster.module.scss'
import { OTA_BUSTER_PERIOD_OPTIONS } from './campaignFlowMock'

function CalendarIcon() {
  return (
    <svg width="17" height="18" viewBox="0 0 17 18" fill="none" aria-hidden="true">
      <path
        d="M5.5 1.5v2M11.5 1.5v2M2.75 7.25h11.5M4.25 3.5h8.5a1.75 1.75 0 011.75 1.75v9a1.75 1.75 0 01-1.75 1.75h-8.5A1.75 1.75 0 012.5 14.25v-9A1.75 1.75 0 014.25 3.5z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  )
}

function PeriodSelector({ value, onChange, disabled }) {
  return (
    <div className={styles.periodSelector}>
      <span className={styles.periodLabel}>Period</span>
      <label className={styles.periodControl}>
        <CalendarIcon />
        <select
          value={value}
          onChange={event => onChange(event.target.value)}
          disabled={disabled}
          aria-label="Analytics period"
          data-testid="ota-buster-period-select"
        >
          {OTA_BUSTER_PERIOD_OPTIONS.map(option => (
            <option key={option.id} value={option.id}>
              {option.label}
            </option>
          ))}
        </select>
      </label>
    </div>
  )
}

PeriodSelector.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
}

PeriodSelector.defaultProps = {
  disabled: false
}

export default PeriodSelector
